/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
let store = {
    debug: true,
    state: {
      name:"",
      credit:0,
      phone:"",
      password:"",
      uid:0,
      admin:0
    },
    login(obj){
      if (this.debug) console.log('login triggered');
      this.state.name=obj.name;
      this.state.credit=obj.credit;
      this.state.phone=obj.phone;
      this.state.password=obj.password;
      this.state.uid=obj.uid;
      this.state.admin=obj.admin;
    },
    logout(){
      if (this.debug) console.log('logout triggered');
      this.state.name='';
      this.state.credit=0;
      this.state.phone='';
      this.state.password='';
      this.state.uid='';
      this.state.admin=0;
    }
}

export {store}